import React, { useState } from "react";
import "./ToolTip.css"; // Import your CSS file for styling
import moment from "moment";

const Tooltip = ({ children, details }) => {
  // // console.log("🚀 ~ Tooltip ~ details:", details);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  let tooltipId;
  let contentShow;

  if (details && details.internalQuality) {
    tooltipId = `my-tooltip-${details._id}`;
    const qualityDetails = details.internalQuality.map((detail, index) => (
      <li key={index} className="toolTip_list">
        {detail}
      </li>
    ));
    contentShow = (
      <div className="w-100">
        <ul className="p-0 m-0">{qualityDetails}</ul>
      </div>
    );
  } else {
    tooltipId = `my-tooltip-${details._id}`;
    let recivedDate = "N/A";
    let updatedDate = "N/A";
    let updatedBy = "N/A";
    let createdAtMoment = "N/A";
    let updatedAtMoment = "N/A";

    if (details.addByDMS) {
      if (details.createdAt) {
        createdAtMoment = moment(details.createdAt).format("ll");
      }
      if (details.updatedAt) {
        updatedAtMoment = moment(details.updatedAt).format("ll");
      }
      if (details.updatedBy) {
        updatedBy = details.updatedBy;
      }
    } else {
      recivedDate = "N/A";
      updatedDate = "N/A";
    }

    contentShow = (
      <div >
        {details.addByDMS ? (
          <ul className="p-0 m-0 pricing_chart_ul">
            <li className="toolTip_list">updatedBy: {updatedBy}</li>
            <li className="toolTip_list">updatedAt: {updatedAtMoment}</li>
            <li className="toolTip_list ">createdAt: {createdAtMoment}</li>
          </ul>
        ) : (
          <ul className="p-0 m-0 pricing_chart_ul">
            <li className="toolTip_list">recivedDate: {recivedDate}</li>
            <li className="toolTip_list">updatedDate: {updatedDate}</li>
          </ul>
        )}
      </div>
    );
  }

  return (
    <div
      className="custom-tooltip-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {showTooltip && (
        <div id={tooltipId} className="custom-tooltip">
          {contentShow}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
